module.exports = __webpack_public_path__ + "img/home-banner-1.73224de5.png";